enum NodeType {
  CAST = 'CAST',
  INPUT = 'INPUT',
  LOWER = 'LOWER',
  MAP = 'MAP',
  FILTER = 'FILTER',
  CLEAR = 'CLEAR',
  UNITE = 'UNITE',
  LEFT_JOIN = 'LEFT_JOIN',
  RENAME = 'RENAME',
  AGGREGATE = 'AGGREGATE',
  CONCATENATE = 'CONCATENATE',
  DATE_PARSER = 'DATE_PARSER',
  REPLACE = 'REPLACE',
  TIME_DIFFERENCE = 'TIME_DIFFERENCE',
  CALCULATE = 'CALCULATE',
  TRIM = 'TRIM',
  TEXT_REPLACE = 'TEXT_REPLACE'
}

export default NodeType
